module.exports = __webpack_public_path__ + "img/Homesimage.d89f4d9e.png";